var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{on:{"click":function($event){return _vm.input.click()}}},[_vm._t("button",function(){return [_c('i',{staticClass:"iconfont iconadd-circle"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }